import { useState } from 'react';

import { RecoverEmail } from './RecoverEmail';
import { SendEmailRecover } from './SendEmailRecover';
import { AuthLayout } from './components/AuthLayout';

import {
  ResponseRecoverEmail,
  EmailsRecuperated,
  DataPostRecoverEmail,
} from '@/types';

export const MainRecoverEmail = () => {
  const [dataRecuperated, setDataRecuperated] = useState<EmailsRecuperated[]>(
    []
  );
  const [dataDoc, setDataDoc] = useState<DataPostRecoverEmail>({
    docNumber: '',
    selectedTypeDoc: { value: -1, label: '' },
  });

  const handleSteps = (r: ResponseRecoverEmail, d: DataPostRecoverEmail) => {
    setDataRecuperated(r.emailsRecuperacion);
    setDataDoc(d);
  };

  return (
    <AuthLayout title="Recordar e-mail">
      {dataRecuperated?.length === 0 ? (
        <RecoverEmail setDataResponse={handleSteps} />
      ) : (
        <SendEmailRecover dataDoc={dataDoc} dataRecuperated={dataRecuperated} />
      )}
    </AuthLayout>
  );
};
